import { UUID } from 'crypto';
import { useQueryParamsHandler } from 'odfjell-query-manager';
import { STOWAGE_PARAMS, DEFAULT_STOWAGE_PARAMS } from '../navigation/stowageNavigationConstants';
import { VOYAGE_NUMBERS_PARAM } from 'src/hooks/useVoyageUrlParams';

export default () => {
    const { triggerQueryParamsUpdate, triggerQueryParamUpdate } = useQueryParamsHandler();

    const setQueryParamStowagePlan = (stowagePlanGuid: UUID, clearAllExcept?: string[]) => {
        triggerQueryParamUpdate(
            { name: STOWAGE_PARAMS.STOWAGE_PLAN_GUID, newValue: stowagePlanGuid },
            { clearAllExcept: [...DEFAULT_STOWAGE_PARAMS, VOYAGE_NUMBERS_PARAM, ...(clearAllExcept ?? [])] }
        );
    };
    const clearQueryParamsStowagePlan = () => {
        triggerQueryParamUpdate({ name: STOWAGE_PARAMS.STOWAGE_PLAN_GUID, clearParam: true }, { clearAllExcept: [...DEFAULT_STOWAGE_PARAMS, VOYAGE_NUMBERS_PARAM] });
    };
    const setQueryParamStowagePortCall = (portCallGuid: UUID) => {
        triggerQueryParamUpdate(
            { name: STOWAGE_PARAMS.PORT_CALL_GUID, newValue: portCallGuid },
            { clearAllExcept: [...DEFAULT_STOWAGE_PARAMS, VOYAGE_NUMBERS_PARAM, STOWAGE_PARAMS.STOWAGE_PLAN_GUID] }
        );
    };
    const setQueryParamStowageBerthCall = (portCallGuid: UUID, berthCallGuid: UUID) => {
        triggerQueryParamsUpdate(
            [
                { name: STOWAGE_PARAMS.PORT_CALL_GUID, newValue: portCallGuid },
                { name: STOWAGE_PARAMS.BERTH_CALL_GUID, newValue: berthCallGuid },
            ],
            { clearAllExcept: [...DEFAULT_STOWAGE_PARAMS, VOYAGE_NUMBERS_PARAM, STOWAGE_PARAMS.STOWAGE_PLAN_GUID] }
        );
    };
    const setQueryParamStowageCargoOperation = (portCallGuid: UUID, cargoOperationGuid: UUID, berthCallGuid?: UUID | null) => {
        const queryParamsToUpdate: { name: string; newValue: UUID }[] = [{ name: STOWAGE_PARAMS.PORT_CALL_GUID, newValue: portCallGuid }];
        if (berthCallGuid) {
            queryParamsToUpdate.push({ name: STOWAGE_PARAMS.BERTH_CALL_GUID, newValue: berthCallGuid });
        }
        queryParamsToUpdate.push({ name: STOWAGE_PARAMS.CARGO_OPERATION_GUID, newValue: cargoOperationGuid });
        triggerQueryParamsUpdate(queryParamsToUpdate, { clearAllExcept: [...DEFAULT_STOWAGE_PARAMS, VOYAGE_NUMBERS_PARAM, STOWAGE_PARAMS.STOWAGE_PLAN_GUID] });
    };
    const clearQueryParamsStowageCargoOperation = () => {
        triggerQueryParamUpdate(
            { name: STOWAGE_PARAMS.CARGO_OPERATION_GUID, clearParam: true },
            {
                clearAllExcept: [
                    ...DEFAULT_STOWAGE_PARAMS,
                    VOYAGE_NUMBERS_PARAM,
                    STOWAGE_PARAMS.STOWAGE_PLAN_GUID,
                    STOWAGE_PARAMS.PORT_CALL_GUID,
                    STOWAGE_PARAMS.BERTH_CALL_GUID,
                ],
            }
        );
    };
    const clearQueryParamsStowageBerthCall = () => {
        triggerQueryParamUpdate(
            { name: STOWAGE_PARAMS.BERTH_CALL_GUID, clearParam: true },
            { clearAllExcept: [...DEFAULT_STOWAGE_PARAMS, VOYAGE_NUMBERS_PARAM, STOWAGE_PARAMS.STOWAGE_PLAN_GUID, STOWAGE_PARAMS.PORT_CALL_GUID] }
        );
    };
    const clearQueryParamsStowagePortCall = () => {
        triggerQueryParamUpdate(
            { name: STOWAGE_PARAMS.PORT_CALL_GUID, clearParam: true },
            { clearAllExcept: [...DEFAULT_STOWAGE_PARAMS, STOWAGE_PARAMS.STOWAGE_PLAN_GUID] }
        );
    };

    return {
        setQueryParamStowagePlan,
        setQueryParamStowagePortCall,
        setQueryParamStowageBerthCall,
        setQueryParamStowageCargoOperation,
        clearQueryParamsStowagePlan,
        clearQueryParamsStowagePortCall,
        clearQueryParamsStowageBerthCall,
        clearQueryParamsStowageCargoOperation,
    };
};
